<app-loading
  [loading] = loading
></app-loading>
<header>
  <div class="row">
    <div class="col-md-2"></div>
    <img class="image img-fluid col-md-3" src="assets/logoSemFundo.png" alt="logo lawservices">
  </div>
  <div class="row">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <h3 style="margin-bottom: 20px; color: white;">Ajudas e artigos da equipe do LawServices</h3>
      <div class="input-group">
        <input type="search" [(ngModel)]="filtro" class="form-control form-control-lg" placeholder="Pesquisar arquivos e artigos...">
        <div class="input-group-append">
          <button type="submit" (click)="buscarFiltro()" class="btn btn-lg btn-secondary">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-8 col-sm-12">
    <app-visualizar-faq
      [faq]="faq"
      [habilitar]="visualizarFaq"
      (eventoFecharVisualizar)="fecharVisualizar()">
    </app-visualizar-faq>
    <div class="text-center text-azul" *ngIf="listaFaqs.length <= 0"> Digite sua dúvida! </div>
    <div *ngIf="!visualizarFaq" id="accordion">
      <div class="card card-primary" style="cursor: pointer" *ngFor="let item of listaFaqs" (click)="setarFaq(item.id)">
        <div class="card-body">
          <h3 class="card-title w-100">
              {{ item.titulo }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>

